"use client";

import React from "react";
import Image from "next/image";
import { Link } from "@/i18n/navigation";
import { MdArrowForward } from "react-icons/md";
import styles from "./explore-banner.module.css";

export default function ExploreBanner() {
  return (
    <div className={styles.outerContainer}>
      <section className={styles.banner}>
        {/* Left Side: Content (Text + Button) */}
        <div className={styles.contentSide}>
          <div className={styles.textWrapper}>
            <h2 className={styles.title}>
              Explore properties across
              <br />
              100+ countries
            </h2>
            <p className={styles.subtitle}>
              Your next home or investment is
              <br />
              just around the world.
            </p>
          </div>

          <Link href="/countries" className={styles.exploreBtn}>
            Explore All Countries
            <MdArrowForward className={styles.btnIcon} />
          </Link>
        </div>

        {/* Right/Bottom Side: Graphic/Image */}
        <div className={styles.imageSide}>
          <div className={styles.imageMask}>
            <Image
              src="/globe_home.png"
              alt="Global Properties"
              fill
              className={styles.graphicImage}
              draggable={false}
            />
          </div>
        </div>
      </section>
    </div>
  );
}
